module.exports = __webpack_public_path__ + "static/media/company-ten.d8cdec0e.jpg";